import './src/styles/globals.css'
import "@fontsource-variable/eb-garamond/wght.css";
import "@fontsource-variable/outfit/wght.css";

import PageRoot from './src/components/PageRoot';

export const wrapPageElement = PageRoot;

